import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import {faArrowLeft} from '@fortawesome/pro-regular-svg-icons';

interface Props {
  changeView: () => void;
}

export const TechnicalsViewSwitcher = ({changeView}: Props) => {
  return <TechnicalsSwitcherContainer onClick={() => changeView()}>
    <FontAwesomeIcon icon={faArrowLeft} style={{marginRight: 10}}/>
      Back to Content
  </TechnicalsSwitcherContainer>;
};

const TechnicalsSwitcherContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  font-size: 12px;
  align-items: center;
  cursor: pointer;
`;
